import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { FaPhoneAlt, FaEnvelope, FaInstagram ,FaMapMarkerAlt} from "react-icons/fa";
import { Link } from "react-router-dom";

const Contact = () => {
  const { company } = useContext(AppContext);

  return (
    <div id="contact" className="px-4 md:px-10 py-8 md:py-12 bg-gray-50">
      
      <div className="max-w-5xl mx-auto text-center md:text-left">
        
        {/* Logo / Brand */}
        <h2 className="text-xl md:text-2xl font-bold mb-2 flex items-center justify-center md:justify-start gap-2">
          <img 
    src={"/images/logo.png"} 
    alt="Aranya Nutraceuticals" 
    className="h-8 w-auto md:h-10"
  />
  <span className="text-lg md:text-xl font-bold">
    Aranya Nutraceuticals
  </span>
        </h2>

        <p className="text-sm text-gray-600 mb-6">
          Reliable herbal raw material & extract supplier across India
        </p>

        {/* Contact Info */}
        <div className="space-y-4 text-sm md:text-base">

          <div className="flex items-center justify-center md:justify-start gap-3">
            <FaPhoneAlt className="text-green-600" />
            <p>{company?.phone}</p>
            <br />
            <FaPhoneAlt className="text-green-600" />
            <p>{company?.phone2}</p>
          </div>

          <div className="flex items-center justify-center md:justify-start gap-3">
            <FaEnvelope className="text-green-600" />
            <p>{company?.email}</p>
          </div>

          {/* <div className="flex items-center justify-center md:justify-start gap-3">
            <FaInstagram className="text-pink-500" />
            <Link
              to="https://instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              @aranya_nutraceuticals
            </Link>
          </div> */}

          <div className="flex items-center justify-center md:justify-start gap-3">
            <FaMapMarkerAlt className="text-green-600" />
            <p>{company?.adress}</p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Contact;